import { MUTATION_KEYS, QUERY_KEYS, LOCIZE_NS } from '@avanta/shared/constants/common';
import { PatientService } from '@avanta/shared/services/patients';
import { type Patient } from '@avanta/shared/types/patients';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { type AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

export const useUpdateInsuredPerson = (
  patientId: string
): UseMutationResult<void, AxiosError, Patient> => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);
  return useMutation({
    mutationKey: [MUTATION_KEYS.UPDATE_EMPLOYEE, patientId],
    mutationFn: async patient => PatientService.updatePatient(patient),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_PATIENT, patientId] });
      toast.success(t('InsuredPersonsList.update.success'));
    },
    onError: () => {
      toast.error(t('InsuredPersonsList.update.error'));
    },
  });
};
